export default __webpack_public_path__ + "static/media/security_low_latency.2d7a1a57.svg";